import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function GallerySection() {
  const [showAllMobile, setShowAllMobile] = useState(false);
  
  const galleryImages = [
    {
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/2aa3237441ba59f594a055061b88aa79.png',
      title: 'Strength Training Area',
      category: 'Equipment'
    },
    {
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/961dd5729a096c7b4ad880cbe855fa4f.png',
      title: 'Cardio Zone',
      category: 'Equipment'
    },
    {
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/7f7ce89cd0d1971dcb5d6917fb2647b6.png',
      title: 'Zumba & Aerobics Classes',
      category: 'Classes'
    },
    {
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/f6ab1846cc770be44559fcba61279e1d.png',
      title: 'HIIT Training',
      category: 'Training'
    },
    {
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/b61e2d35333ea0633f904052158ced23.png',
      title: 'Personal Training',
      category: 'Training'
    },
    {
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/7919c1dc89a9e853180fe7b8b7ebac1b.png',
      title: 'Main Gym Floor',
      category: 'Facility'
    }
  ];

  return (
    <section id="gallery" className="py-6 lg:py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-4 lg:mb-16">
          <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-600/20 border border-red-500/50 text-red-400 rounded-lg text-[10px] lg:text-sm font-bold mb-2 lg:mb-4 uppercase tracking-wider">
            OUR FACILITY
          </div>
          <h3 className="text-xl lg:text-6xl font-black text-white mb-1.5 lg:mb-6 tracking-tight">
            See What Makes Us <span className="text-red-500">Kenya's Biggest</span>
          </h3>
          <p className="text-[10px] lg:text-xl text-gray-400 max-w-3xl mx-auto hidden lg:block">
            Take a virtual tour of our state-of-the-art facility
          </p>
        </div>

        {/* Gallery Grid - Show 4 on mobile by default, all on desktop */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-1.5 lg:gap-6">
          {galleryImages.map((item, index) => (
            <div
              key={index}
              className={`group relative rounded-lg lg:rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-red-600/20 transition-all duration-500 hover:-translate-y-2 cursor-pointer h-24 lg:h-80 ${
                !showAllMobile && index >= 4 ? 'hidden lg:block' : ''
              }`}
            >
              {/* Image */}
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-1.5 lg:p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                <div className="inline-block px-1 py-0.5 lg:px-3 lg:py-1 bg-red-600/80 backdrop-blur-sm text-white text-[7px] lg:text-xs font-bold rounded mb-0.5 lg:mb-2 uppercase tracking-wider">
                  {item.category}
                </div>
                <h4 className="text-[10px] lg:text-2xl font-black text-white leading-tight">
                  {item.title}
                </h4>
              </div>

              {/* Hover Icon - Hidden on mobile */}
              <div className="hidden lg:flex absolute top-4 right-4 w-12 h-12 bg-red-600 rounded-full items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform scale-0 group-hover:scale-100">
                <i className="ri-image-line text-white text-xl"></i>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button - Mobile Only */}
        {!showAllMobile && (
          <div className="lg:hidden text-center mt-3">
            <Button
              onClick={() => setShowAllMobile(true)}
              variant="primary"
              icon="ri-arrow-down-s-line"
              iconPosition="right"
              className="text-[10px] px-4 py-2"
            >
              View All Gallery
            </Button>
          </div>
        )}

        {/* CTA */}
        <div className="text-center mt-4 lg:mt-12">
          <p className="text-gray-400 mb-2 lg:mb-6 text-[10px] lg:text-base hidden lg:block">
            Experience our facility with a <strong className="text-white">free tour</strong>
          </p>
          <div className="flex flex-wrap gap-1.5 lg:gap-4 justify-center">
            <Button
              href="tel:+254795568891"
              variant="cta"
              icon="ri-calendar-check-line"
              iconPosition="left"
              className="text-[10px] lg:text-base px-3 py-2 lg:px-8 lg:py-4"
            >
              Book Your Tour
            </Button>
            <Button
              href="#contact"
              variant="secondary"
              icon="ri-map-pin-line"
              iconPosition="left"
              className="text-[10px] lg:text-base px-3 py-2 lg:px-8 lg:py-4"
            >
              Get Directions
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
